import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import { ErrorBoundary } from "@/app/ErrorBoundary";
import { Providers } from "@/app/providers";
import { router } from "@/app/router";
import { initializeSentry } from "@/sentry";

import "./index.css";

initializeSentry();

createRoot(
  document.getElementById("root")!,
).render(
  <StrictMode>
    <Providers>
      <ErrorBoundary>
        <RouterProvider router={router} />
      </ErrorBoundary>
    </Providers>
  </StrictMode>,
);